var React = require('react');

function AsanaLizard (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M1,36c0,0,4.563,1,8.313,1\n\tC15.063,37,29,30.562,29,30.562V37h5 M25.031,14.758c-4.222,7.993-8.968,15.692-12.774,17.499C8.45,34.064,1,33.188,1,33.188V38\n\t M22.663,27.19c0,0,6.12-2.308,8.65-2.308c1.06,0,1.749,0.867,1.749,2.055c0,1.563-1,10.063-1,10.063 M28.218,13.322l2.22-4.345\n\tc0,0-4.715-3-5.367-3.35c-1.965-1.057-4.084-0.937-5.453,1.609c-1.37,2.546-0.303,4.38,1.662,5.437\n\tc0.652,0.35,1.533,0.897,3.752,2.085C28.486,16.609,29,17.808,29,21c0,1.252,0,13.643,0,17"}));
}

AsanaLizard.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaLizard;

AsanaLizard.default = AsanaLizard;
